import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/messages/en.json';
import es from '@/messages/es.json';

// The sponsor deck and the tour sponsor page are the only bilingual pages in the app
// (`app/[locale]/**` over there). PORTING.md U5 keeps the message keys exactly as
// next-intl had them and swaps `useTranslations` for react-i18next's `useTranslation`;
// `src/messages/{es,en}.json` are copied verbatim into `app/frontend/messages`.
//
// next-intl interpolates ICU single braces (`{percent}`), so i18next is configured with
// the same delimiters rather than its own `{{percent}}`.
if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: { es: { translation: es }, en: { translation: en } },
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
  });
}

export default i18n;
